import {
  zipCode,
  consumption,
  consumptionKnown,
  consumptionWithPower,
  fuelConsumption,
  woodConsumption,
  electricityConsumption,
  energy,
  building,
  buildingDate,
  buildingType,
  mobility,
} from './questions';

// All prices are without VAT
export const GNC_PRICE_PER_KG = 1.332;
export const GNC_BIOGAZ_PRICE_PER_KG = 0.57;
export const GNC_BIOGAZ_PERCENT_INCLUDED = 20;

export default {
  energies: {
    gas: {
      icon: 'gas',
      label: gettext('Gaz naturel-biogaz'),
    },
    fuel: {
      icon: 'fuel',
      label: gettext('Mazout'),
    },
    wood: {
      icon: 'wood',
      label: gettext('Bois'),
    },
    electricity: {
      icon: 'electricity',
      label: gettext('Électricité'),
    },
  },
  usages: {
    heating: {
      icon: 'heating',
      name: gettext('Chauffage'),
      description: gettext(
        'Tous les usages ménagers raccordés au compteur chauffage.'
      ),
      questions: [
        energy,
        zipCode,
        building,
        {
          question: consumptionKnown,
          paths: [
            {
              matches(simulation) {
                return simulation.consumptionKnown === false;
              },
              questions: [buildingDate, buildingType],
            },
            {
              matches(simulation) {
                return (
                  simulation.consumptionKnown === true &&
                  simulation.energy === 'fuel'
                );
              },
              questions: [fuelConsumption],
            },
            {
              matches(simulation) {
                return (
                  simulation.consumptionKnown === true &&
                  simulation.energy === 'wood'
                );
              },
              questions: [woodConsumption],
            },
            {
              matches(simulation) {
                return (
                  simulation.consumptionKnown === true &&
                  simulation.energy === 'electricity'
                );
              },
              questions: [electricityConsumption],
            },
            {
              matches(simulation) {
                return (
                  simulation.consumptionKnown === true &&
                  simulation.energy === 'gas'
                );
              },
              questions: [consumptionWithPower],
            },
          ],
        },
      ],
      mainProduct: {
        type: 'product',
        name: 'Basic10',
        label: '10%',
        bioIcon: 'bio-low',
        // It’s 10% in reality but it’s already included in the price
        percentage: 0,
      },
      products: [
        {
          type: 'product',
          name: 'BiogazCH',
          label: '100%',
          bioIcon: 'bio-high',
          percentage: 100,
        },
      ],
    },
    cooking: {
      icon: 'cooking',
      name: gettext('Cuisson'),
      description: gettext('Cuisson privée ou professionnelle.'),
      questions: [zipCode, consumption],
      mainProduct: {
        type: 'product',
        name: 'Basic10',
        label: '10%',
        bioIcon: 'bio-low',
        // It’s 10% in reality but it’s already included in the price
        percentage: 0,
      },
      products: [
        {
          type: 'product',
          name: 'BiogazCH',
          label: '100%',
          bioIcon: 'bio-high',
          percentage: 100,
        },
      ],
    },
    mobility: {
      icon: 'mobility',
      name: gettext('Mobilité'),
      description: gettext('Mobilité au gaz naturel-biogaz.'),
      questions: [mobility],
      certificates: [
        {
          type: 'certificate',
          name: 'GNC',
          label: '100%',
          bioIcon: 'bio-high',
          percentage: 100,
        },
      ],
    },
    industrial: {
      icon: 'industrial',
      name: gettext('Industrie et autres usages'),
      description: gettext(
        'Procédés industriels ou autres usages non couplés au chauffage.'
      ),
      questions: [consumptionWithPower],
      mainProduct: {
        type: 'product',
        name: 'Basic10',
        label: '10%',
        bioIcon: 'bio-low',
        // It’s 10% in reality but it’s already included in the price
        percentage: 0,
      },
      products: [
        {
          type: 'product',
          name: 'BiogazCH',
          label: '100%',
          bioIcon: 'bio-high',
          percentage: 100,
        },
      ],
    },
  },
  rates: {
    comfort: [
      {
        min: 500000,
        prices: {
          0: 0.1364,
          100: 0.1764,
        },
        power: 23.2,
        subscription: 300,
      },
      {
        min: 250000,
        prices: {
          0: 0.13905,
          100: 0.17905,
        },
        power: 23.2,
        subscription: 240,
      },
      {
        min: 100000,
        prices: {
          0: 0.1406,
          100: 0.1806,
        },
        power: 23.2,
        subscription: 215,
      },
      {
        min: 25000,
        prices: {
          0: 0.1443,
          100: 0.1843,
        },
        power: 23.2,
        subscription: 90,
      },
      {
        min: 0,
        prices: {
          0: 0.14585,
          100: 0.18585,
        },
        power: 23.2,
        subscription: 90,
      },
    ],
    cooking: [
      {
        min: 1000,
        prices: {
          0: 0.20835,
          100: 0.24835,
        },
        power: 0,
        subscription: 90,
      },
      {
        min: 0,
        prices: {
          0: 0.2503,
          100: 0.2903,
        },
        power: 0,
        subscription: 90,
      },
    ],
    other: [
      {
        min: 500000,
        prices: {
          0: 0.13115,
          100: 0.17115,
        },
        power: 4,
        subscription: 300,
      },
      {
        min: 250000,
        prices: {
          0: 0.1316,
          100: 0.1716,
        },
        power: 4,
        subscription: 240,
      },
      {
        min: 100000,
        prices: {
          0: 0.13165,
          100: 0.17165,
        },
        power: 4,
        subscription: 215,
      },
      {
        min: 25000,
        prices: {
          0: 0.13325,
          100: 0.17325,
        },
        power: 6,
        subscription: 90,
      },
      {
        min: 0,
        prices: {
          0: 0.15215,
          100: 0.19215,
        },
        // Special case: calculation may ignore this power price in particular,
        // depending on the estimated consumption and power.
        power: 6,
        subscription: 90,
      },
    ],
  },
  buildings: {
    standard: {
      old: {
        low: {
          primary: {
            consumption: 12000,
            power: 10,
          },
          secondary: {
            consumption: 10200,
            power: 10,
          },
        },
        high: {
          primary: {
            consumption: 14000,
            power: 10,
          },
          secondary: {
            consumption: 9000,
            power: 10,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 8000,
            power: 7,
          },
          secondary: {
            consumption: 8000,
            power: 7,
          },
        },
        high: {
          primary: {
            consumption: 8000,
            power: 7,
          },
          secondary: {
            consumption: 8000,
            power: 7,
          },
        },
      },
    },
    smallHouse: {
      old: {
        low: {
          primary: {
            consumption: 15000,
            power: 15,
          },
          secondary: {
            consumption: 12750,
            power: 15,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 8000,
            power: 8,
          },
          secondary: {
            consumption: 8000,
            power: 8,
          },
        },
      },
    },
    mediumHouse: {
      old: {
        low: {
          primary: {
            consumption: 20000,
            power: 20,
          },
          secondary: {
            consumption: 17000,
            power: 20,
          },
        },
        high: {
          primary: {
            consumption: 20000,
            power: 20,
          },
          secondary: {
            consumption: 13000,
            power: 20,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 10000,
            power: 10,
          },
          secondary: {
            consumption: 10000,
            power: 10,
          },
        },
        high: {
          primary: {
            consumption: 10000,
            power: 10,
          },
          secondary: {
            consumption: 10000,
            power: 10,
          },
        },
      },
    },
    largeHouse: {
      old: {
        low: {
          primary: {
            consumption: 25000,
            power: 25,
          },
          secondary: {
            consumption: 21250,
            power: 25,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 15000,
            power: 15,
          },
          secondary: {
            consumption: 15000,
            power: 15,
          },
        },
      },
    },
    twinHouse: {
      old: {
        low: {
          primary: {
            consumption: 20000,
            power: 20,
          },
          secondary: {
            consumption: 17000,
            power: 20,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 8000,
            power: 8,
          },
          secondary: {
            consumption: 8000,
            power: 8,
          },
        },
      },
    },
    building: {
      old: {
        low: {
          primary: {
            consumption: 100000,
            power: 70,
          },
          secondary: {
            consumption: 85000,
            power: 70,
          },
        },
        high: {
          primary: {
            consumption: 120000,
            power: 80,
          },
          secondary: {
            consumption: 120000,
            power: 80,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 50000,
            power: 35,
          },
          secondary: {
            consumption: 50000,
            power: 35,
          },
        },
        high: {
          primary: {
            consumption: 60000,
            power: 35,
          },
          secondary: {
            consumption: 60000,
            power: 35,
          },
        },
      },
    },
    huge: {
      old: {
        low: {
          primary: {
            consumption: 0,
            power: 0,
          },
          secondary: {
            consumption: 0,
            power: 0,
          },
        },
      },
      new: {
        low: {
          primary: {
            consumption: 0,
            power: 0,
          },
          secondary: {
            consumption: 0,
            power: 0,
          },
        },
      },
    },
  },
};
